<script>
import 'swiper/css/swiper.min.css' 
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import store from '../store/index.js';
import { findIndex, reduce } from 'lodash';
export default {
	data() {
        return {
            title: store.carSeries.title,
			list: store.carSeries.series.list,
            swiperOptionTab: {
				slidesPerView: 'auto',
				freeMode: true,
  	        	// spaceBetween: 10,
				grabCursor: true,
				slideToClickedSlide: true
  	        },
            swiperOption: {
	        	slidesPerView: 'auto',
	        	centeredSlides: true,
	        	grabCursor: true,
				slideToClickedSlide: true
	        }
        }
    },
    computed: {
    	tabSwiper() {
        	return this.$refs.tabSwiper.swiper;
    	},
    	imgSwiper() {
        	return this.$refs.imgSwiper.swiper;
		},
		seriesId() {
			return store.form.series.id;
		},
		index() {
			return findIndex(this.list, item => item.id === this.seriesId); 
		}
	},
	methods: {
		change() {
			const item = this.list[this.imgSwiper.activeIndex];
			const prev = this.list[this.imgSwiper.previousIndex];
			if (item) {
				store.form.series.id = item.id;
				store.form.series.name = item.name;
				store.form.series.taskid = item.taskid;
			}
			// 埋点上报
			this.$clickMonitor.send({
				buttonId: `series-${item.id}-enter`,
				...store.getClickMonitorParams()
			});
			if (prev) {
				this.$clickMonitor.send({
					buttonId: `series-${prev.id}-leave`,
					...store.getClickMonitorParams()
				});
			}
		},
		tabClick(index) {
			this.imgSwiper.slideTo(index);
			this.transitionStart();
		},
		transitionStart() {
			const activeIndex = this.imgSwiper.activeIndex;
			const prevIndex = this.imgSwiper.previousIndex;
			const curTabItem = this.tabSwiper.slides[activeIndex];
			const prevTabItem = this.tabSwiper.slides[prevIndex];
			const curTabItemWidth = curTabItem.offsetWidth;
			const tabClientWidth = this.tabSwiper.width;
			const activeTableLeft = curTabItem.offsetLeft;
			const tabWidth = reduce(this.tabSwiper.slides, (width, item) => {
				width += item.offsetWidth;
				return width;
			}, 0);
			curTabItem.querySelector('.tab-item').style.backgroundColor = '#E7D1FF';
			if (prevTabItem) {
				prevTabItem.querySelector('.tab-item').style.backgroundColor = '#8E71BE';
			}
			this.tabSwiper.setTransition(300);
			if (activeTableLeft < (tabClientWidth - curTabItemWidth) / 2) {
				this.tabSwiper.setTranslate(0);
			} else if (activeTableLeft > tabWidth - (curTabItemWidth + tabClientWidth) / 2) {
				this.tabSwiper.setTranslate(tabClientWidth - tabWidth);
			} else {
				this.tabSwiper.setTranslate((tabClientWidth - curTabItemWidth) / 2 - activeTableLeft);
			}
		}
	},
    components: {
	    swiper,
	    swiperSlide
	},
    mounted() {
		this.$nextTick(() => {
			const tabSwiper = this.$refs.tabSwiper.swiper;
			const imgSwiper = this.$refs.imgSwiper.swiper;
			// tabSwiper.controller.control = imgSwiper;
			// imgSwiper.controller.control = tabSwiper;
			this.transitionStart();
			this.$watch('index', function () {
				imgSwiper.slideTo(this.index);
			}, {immediate: true});
			this.change();
		});
    }
}
</script>

<template>
    <div class="wrap">
    	<div class="title">
        	{{title}}
			<i class="title-icon"></i>
        </div>
        <div class="tab-swiper-wrap">
        	<swiper class="tab-swiper-inner" :options="swiperOptionTab" ref="tabSwiper">
        		<swiper-slide v-for="(slide, index) in list" :key="slide.id">
        			<div class="tab-item series-tab" :data-id="slide.id" @click="tabClick(index)">{{slide.tabName}}</div>
        		</swiper-slide>
        	</swiper>
        </div>
        <div class="img-swiper-wrap">
        	<swiper
				class="img-swiper-inner"
				:options="swiperOption"
				ref="imgSwiper"
				@slideChange="change"
				@transitionStart="transitionStart"
			>
        		<swiper-slide v-for="slide in list" :key="slide.id" :data-id="slide.id">
        			<img :src="slide.image" alt="" class="slide-img">
        			<div class="slide-tip">{{slide.policy}}</div>
        		</swiper-slide>
        	</swiper>
        </div>
    </div>
</template>
<style lang="stylus" scoped>
.title
	margin 0 0 0.875rem
.tab-swiper-wrap
	margin-bottom 1.066rem
	font-size 0
	.swiper-slide
		width auto
	// 	display inline-block
	// 	padding 0 0.85rem
	// 	width auto
	// 	height 1.70rem
	// 	line-height 1.70rem
	// 	border-radius:16px;
	// 	box-shadow 0px 2px 9px -4px rgba(0,0,0,0.5);
	// 	font-size 0.853rem
	// 	background-color #8E71BE;
	// 	color #35008B
	// 	transition all .225s ease
	.tab-item
		// margin 0 0.266rem
		margin 0 0.4rem
		padding 0 0.85rem
		width auto
		height 1.70rem
		line-height 1.70rem
		border-radius:16px;
		box-shadow 0px 2px 9px -4px rgba(0,0,0,0.5);
		font-size 0.853rem
		background-color #8E71BE;
		color #35008B
		transition all .225s ease
	// .tab-swiper-inner
		// padding 0 0.8rem
	// .tab-swiper-inner .swiper-slide-active .tab-item
	// 	background-color #E7D1FF
.img-swiper-wrap
	height 8.53rem
	.swiper-container
		height 100%
	.swiper-slide
		position relative
		width 15.14rem
		height 100%
		background #fff
		background linear-gradient(360deg,rgba(255,255,255,1) 0%,rgba(255,239,205,1) 100%)
		border-radius 0.53rem
		transition all .225s ease
		transform scale(0.9)
		overflow hidden
	.slide-img
		position absolute
		bottom -0.5rem
		left 0
		right 0
		margin auto
		max-width 12.8rem
		max-height 8rem
		border-radius 10px
		transform scale(1.7)
	.slide-tip
		position absolute
		left 0
		top 0.426rem
		padding 0 0.53rem
		height 1.6rem
		line-height 1.6rem
		background #396A00
		border-radius 0 .8rem .8rem 0
		color #B8E986
		font-weight 500
		font-size 0.64rem
		box-sizing border-box
	.img-swiper-inner .swiper-slide-active
		transform scale(1)
		background linear-gradient(180deg,rgba(250,217,97,1) 0%,rgba(247,107,28,1) 100%)
</style>